// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__EUkxP","sendButton":"styles_sendButton__n7IeY","imageWrapper":"styles_imageWrapper__J4N0Q"};